const firstRetryMs = 5 * 1000;
const slowestRetryMs = 60 * 1000;
const refusedRetryMs = 5 * 60 * 1000;

/**
 * @param {object} attempt
 * @param {boolean} [attempt.refused] - the server answered that it hands out no channel
 * @param {number} [attempt.failCount] - failed attempts in a row
 * @returns {number} how long to wait before asking for a websocket again
 */
const wsRetryDelayMs = ({ refused = false, failCount = 0 }) => {
  // Only a fix on the server side ends a refusal, asking again quickly brings nothing
  if (refused) return refusedRetryMs;

  const doublings = Math.min(Math.max(failCount - 1, 0), 10);

  return Math.min(firstRetryMs * (2 ** doublings), slowestRetryMs);
};

export default wsRetryDelayMs;
